import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	paginationMessage: {
		id: 'servicedesk-reports-common.table.pagination-count-label.pagination-message',
		defaultMessage: '{start}-{end} of {size}',
		description: 'pagination label message for {start}-{end} of {size}',
	},
});
